<template>
  <div id="wrapper" v-loading.fullscreen.lock="loadingFlag">
    <!--左侧导航开始-->
    <nav class="navbar-default navbar-static-side" role="navigation">
        <div class="nav-close"><i class="fa fa-times-circle"></i>
        </div>
        <div class="sidebar-collapse">
            <ul class="nav" id="side-menu">
                <li class="nav-header">
                    <div class="dropdown profile-element">
                        <span class="logoSty"><img alt="image" class="img-circle" src="../../assets/img/logo.png" /></span>
                        <a data-toggle="dropdown" class="dropdown-toggle" href="#">
                            <span class="clear">
                            <span class="block m-t-xs"><strong class="font-bold">欢迎您, {{userName}} !</strong></span>
                            <!-- <span class="text-muted text-xs block">信息管理<b class="caret"></b></span> -->

                            </span>

                        </a>

                        <div style="padding:10px">
                          <a style='font-size:14px;font-weight:200;'>
                           <i style='margin-left:5px;'></i>
                           余额：{{surplus}}元  
                          </a>
                        </div>
                        <div style="padding:10px">
                          <button class="el-button btn-outline el-button--default el-button--small is-plain" @click="goReCharge">去充值</button>
                          <button class="el-button btn-outline el-button--default el-button--small is-plain" @click="reFreshReCharge">刷新</button>
                        </div>

                       <a class="J_menuItem msg" src="./notice.html#/inbox">
                        <i style='margin-right:5px' class="fa fa-envelope-o"></i>
                        消息
                        </a>

                        <!-- <ul class="dropdown-menu animated fadeInRight m-t-xs">
                            <li><a class="J_menuItem" @click='consult'>在线咨询</a>
                            <li class="divider"></li>
                            <li>
                                <a @click="exitSys">安全退出</a>
                            </li>
                        </ul> -->

                    </div>
                    <div class="logo-element">H+
                    </div>
                </li>
                <!--开始遍历菜单-->
                <template :v-bind= "menus">
                    <template v-if="menus!=undefined">
                        <li v-for="(item,index) in menus" :key="index">
                            <template v-if='item.menuLevel'>
                                <a class="J_menuItem" src="./main.html"  v-if="item.moduleID==11063">
                                    <i class="fa fa-home"></i>
                                    <span class="nav-label">{{item.moduleName}}</span>
                                </a>
                                <a href="#" v-else :moduleID='item.moduleID' :op="item.operation ? JSON.stringify(item.operation) : false">
                                    <i class="fa fa fa-bar-chart-o"></i>
                                    <span class="nav-label">{{item.moduleName}}</span>
                                    <span class="fa arrow"></span>
                                </a>
                                <ul class="nav nav-second-level" v-if="item.childs.length>0">
                                    <li v-for="(citem,cindex) in item.childs" :key="cindex">
                                        <a @click="addFUS(citem.funcID,citem.childs)" class="J_menuItem"  :src="citem.url" :op="citem.operation ? JSON.stringify(citem.operation) : false" :funcID='citem.funcID'>{{citem.moduleName||citem.funcName || citem.analysisReportName}}</a>
                                        <ul class="nav nav-third-level" v-if="citem.childs&&citem.childs.length>0">
                                            <li v-for="(ccitem,ccindex) in citem.childs" :key="ccindex">
                                                <a class="J_menuItem" @click="addFUS(ccitem.funcID)" :src="ccitem.url" :op="ccitem.operation ? JSON.stringify(ccitem.operation): false">{{ccitem.reportName||ccitem.funcName}}</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </template>
                        </li>
                    </template>
                    <template v-else>
                        <li>
                            <a href="#">
                                    <i class="fa fa-home"></i>
                                    <span class="nav-label">对不起,菜单加载异常!</span>
                                    <span class="fa arrow"></span>
                            </a>
                        </li>
                    </template>
                </template>
            </ul>
        </div>
    </nav>
    <!--左侧导航结束-->
    <!--右侧部分开始-->
    <div id="page-wrapper" class="gray-bg dashbard-1">
        <div class="row border-bottom">
            <!-- <nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0">
                <div class="navbar-header"><a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="#"><i class="fa fa-bars"></i> </a>
                    <form role="search" class="navbar-form-custom" method="post" action="search_results.html">
                        <div class="form-group">
                            <input type="text" placeholder="请输入您需要查找的内容 …" class="form-control" name="top-search" id="top-search">
                        </div>
                    </form>
                </div>
                <ul class="nav navbar-top-links navbar-right">
                    <li class="dropdown">
                        <a class="dropdown-toggle count-info" data-toggle="dropdown" href="#">
                            <i class="fa fa-envelope"></i> <span class="label label-warning">16</span>
                        </a>
                        <ul class="dropdown-menu dropdown-messages">
                            <li class="m-t-xs">
                                <div class="dropdown-messages-box">
                                    <a href="profile.html" class="pull-left">
                                        <img alt="image" class="img-circle" src="../../assets/img/a7.jpg">
                                    </a>
                                    <div class="media-body">
                                        <small class="pull-right">46小时前</small>
                                        <strong>小四</strong> 这个在日本投降书上签字的军官，建国后一定是个不小的干部吧？
                                        <br>
                                        <small class="text-muted">3天前 2014.11.8</small>
                                    </div>
                                </div>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <div class="dropdown-messages-box">
                                    <a href="profile.html" class="pull-left">
                                        <img alt="image" class="img-circle" src="../../assets/img/a4.jpg">
                                    </a>
                                    <div class="media-body ">
                                        <small class="pull-right text-navy">25小时前</small>
                                        <strong>国民岳父</strong> 如何看待“男子不满自己爱犬被称为狗，刺伤路人”？——这人比犬还凶
                                        <br>
                                        <small class="text-muted">昨天</small>
                                    </div>
                                </div>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <div class="text-center link-block">
                                    <a class="J_menuItem" href="mailbox.html">
                                        <i class="fa fa-envelope"></i> <strong> 查看所有消息</strong>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li class="dropdown">
                        <a class="dropdown-toggle count-info" data-toggle="dropdown" href="#">
                            <i class="fa fa-bell"></i> <span class="label label-primary">8</span>
                        </a>
                        <ul class="dropdown-menu dropdown-alerts">
                            <li>
                                <a href="mailbox.html">
                                    <div>
                                        <i class="fa fa-envelope fa-fw"></i> 您有16条未读消息
                                        <span class="pull-right text-muted small">4分钟前</span>
                                    </div>
                                </a>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <a href="profile.html">
                                    <div>
                                        <i class="fa fa-qq fa-fw"></i> 3条新回复
                                        <span class="pull-right text-muted small">12分钟钱</span>
                                    </div>
                                </a>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <div class="text-center link-block">
                                    <a class="J_menuItem" href="notifications.html">
                                        <strong>查看所有 </strong>
                                        <i class="fa fa-angle-right"></i>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li class="hidden-xs">
                        <a href="./main.html" class="J_menuItem" data-index="0"><i class="fa fa-cart-arrow-down"></i> 购买</a>
                    </li>
                    <li class="dropdown hidden-xs">
                        <a class="right-sidebar-toggle" aria-expanded="false">
                            <i class="fa fa-tasks"></i> 主题
                        </a>
                    </li>
                </ul>
            </nav> -->
        </div>
        <div class="row content-tabs">
            <button class="roll-nav roll-left J_tabLeft"><i class="fa fa-backward"></i>
            </button>
            <nav class="page-tabs J_menuTabs">
                <div class="page-tabs-content">
                    <a href="javascript:" class="active J_menuTab" data-id="./main.html">首页</a>
                </div>
            </nav>
            <button class="roll-nav roll-right J_tabRight"><i class="fa fa-forward"></i>
            </button>
            <div class="btn-group roll-nav roll-right">
                <button class="dropdown J_tabClose" data-toggle="dropdown">关闭操作<span class="caret"></span>

                </button>
                <ul role="menu" class="dropdown-menu dropdown-menu-right">
                    <li class="J_tabCloseAll"><a>关闭全部选项卡</a>
                    </li>
                    <li class="J_tabCloseOther"><a>关闭其他选项卡</a>
                    </li>
                </ul>
            </div>
            <a  @click="exitSys" class="roll-nav roll-right J_tabExit"><i class="fa fa fa-sign-out"></i> 退出</a>
        </div>
        <div class="row J_mainContent" id="content-main">
            <!--<iframe class="J_iframe" name="iframe0" width="100%" height="100%" src="./main.html" frameborder="0" data-id="./main.html" seamless></iframe>-->
        </div>
        <!--<div class="footer">
            <div class="pull-right">&copy; 2018 <span>www.baojianyuan.com</span>
            </div>
        </div>-->
    </div>
    <!--右侧部分结束-->
    <!--右侧边栏开始-->
    <div id="right-sidebar">
        <div class="sidebar-container">

            <ul class="nav nav-tabs navs-3">

                <li class="active">
                    <a data-toggle="tab" href="#tab-1">
                        <i class="fa fa-gear"></i> 主题
                    </a>
                </li>
                <li class=""><a data-toggle="tab" href="#tab-2">
                    通知
                </a>
                </li>
                <li><a data-toggle="tab" href="#tab-3">
                    项目进度
                </a>
                </li>
            </ul>

            <div class="tab-content">
                <div id="tab-1" class="tab-pane active">
                    <div class="sidebar-title">
                        <h3> <i class="fa fa-comments-o"></i> 主题设置</h3>
                        <small><i class="fa fa-tim"></i> 你可以从这里选择和预览主题的布局和样式，这些设置会被保存在本地，下次打开的时候会直接应用这些设置。</small>
                    </div>
                    <div class="skin-setttings">
                        <div class="title">主题设置</div>
                        <div class="setings-item">
                            <span>收起左侧菜单</span>
                            <div class="switch">
                                <div class="onoffswitch">
                                    <input type="checkbox" name="collapsemenu" class="onoffswitch-checkbox" id="collapsemenu">
                                    <label class="onoffswitch-label" for="collapsemenu">
                                        <span class="onoffswitch-inner"></span>
                                        <span class="onoffswitch-switch"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="setings-item">
                            <span>固定顶部</span>

                            <div class="switch">
                                <div class="onoffswitch">
                                    <input type="checkbox" name="fixednavbar" class="onoffswitch-checkbox" id="fixednavbar">
                                    <label class="onoffswitch-label" for="fixednavbar">
                                        <span class="onoffswitch-inner"></span>
                                        <span class="onoffswitch-switch"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="setings-item">
                            <span>
                    固定宽度
                </span>

                            <div class="switch">
                                <div class="onoffswitch">
                                    <input type="checkbox" name="boxedlayout" class="onoffswitch-checkbox" id="boxedlayout">
                                    <label class="onoffswitch-label" for="boxedlayout">
                                        <span class="onoffswitch-inner"></span>
                                        <span class="onoffswitch-switch"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="title">皮肤选择</div>
                        <div class="setings-item default-skin nb">
                            <span class="skin-name ">
                      <a href="#" class="s-skin-0">
                          默认皮肤
                      </a>
                </span>
                        </div>
                        <div class="setings-item blue-skin nb">
                            <span class="skin-name ">
                    <a href="#" class="s-skin-1">
                        蓝色主题
                    </a>
                </span>
                        </div>
                        <div class="setings-item yellow-skin nb">
                            <span class="skin-name ">
                    <a href="#" class="s-skin-3">
                        黄色/紫色主题
                    </a>
                </span>
                        </div>
                    </div>
                </div>
                <div id="tab-2" class="tab-pane">

                    <div class="sidebar-title">
                        <h3> <i class="fa fa-comments-o"></i> 最新通知</h3>
                        <small><i class="fa fa-tim"></i> 您当前有10条未读信息</small>
                    </div>

                    <div>

                        <div class="sidebar-message">
                            <a href="#">
                                <div class="pull-left text-center">
                                    <img alt="image" class="img-circle message-avatar" src="../../assets/img/a1.jpg">

                                    <div class="m-t-xs">
                                        <i class="fa fa-star text-warning"></i>
                                        <i class="fa fa-star text-warning"></i>
                                    </div>
                                </div>
                                <div class="media-body">

                                    据天津日报报道：瑞海公司董事长于学伟，副董事长董社轩等10人在13日上午已被控制。
                                    <br>
                                    <small class="text-muted">今天 4:21</small>
                                </div>
                            </a>
                        </div>
                        <div class="sidebar-message">
                            <a href="#">
                                <div class="pull-left text-center">
                                    <img alt="image" class="img-circle message-avatar" src="../../assets/img/a2.jpg">
                                </div>
                                <div class="media-body">
                                    HCY48之音乐大魔王会员专属皮肤已上线，快来一键换装拥有他，宣告你对华晨宇的爱吧！
                                    <br>
                                    <small class="text-muted">昨天 2:45</small>
                                </div>
                            </a>
                        </div>
                        <div class="sidebar-message">
                            <a href="#">
                                <div class="pull-left text-center">
                                    <img alt="image" class="img-circle message-avatar" src="../../assets/img/a3.jpg">

                                    <div class="m-t-xs">
                                        <i class="fa fa-star text-warning"></i>
                                        <i class="fa fa-star text-warning"></i>
                                        <i class="fa fa-star text-warning"></i>
                                    </div>
                                </div>
                                <div class="media-body">
                                    写的好！与您分享
                                    <br>
                                    <small class="text-muted">昨天 1:10</small>
                                </div>
                            </a>
                        </div>
                        <div class="sidebar-message">
                            <a href="#">
                                <div class="pull-left text-center">
                                    <img alt="image" class="img-circle message-avatar" src="../../assets/img/a4.jpg">
                                </div>

                                <div class="media-body">
                                    国外极限小子的炼成！这还是亲生的吗！！
                                    <br>
                                    <small class="text-muted">昨天 8:37</small>
                                </div>
                            </a>
                        </div>
                        <div class="sidebar-message">
                            <a href="#">
                                <div class="pull-left text-center">
                                    <img alt="image" class="img-circle message-avatar" src="../../assets/img/a8.jpg">
                                </div>
                                <div class="media-body">

                                    一只流浪狗被收留后，为了减轻主人的负担，坚持自己觅食，甚至......有些东西，可能她比我们更懂。
                                    <br>
                                    <small class="text-muted">今天 4:21</small>
                                </div>
                            </a>
                        </div>
                        <div class="sidebar-message">
                            <a href="#">
                                <div class="pull-left text-center">
                                    <img alt="image" class="img-circle message-avatar" src="../../assets/img/a7.jpg">
                                </div>
                                <div class="media-body">
                                    这哥们的新视频又来了，创意杠杠滴，帅炸了！
                                    <br>
                                    <small class="text-muted">昨天 2:45</small>
                                </div>
                            </a>
                        </div>
                        <div class="sidebar-message">
                            <a href="#">
                                <div class="pull-left text-center">
                                    <img alt="image" class="img-circle message-avatar" src="../../assets/img/a3.jpg">

                                    <div class="m-t-xs">
                                        <i class="fa fa-star text-warning"></i>
                                        <i class="fa fa-star text-warning"></i>
                                        <i class="fa fa-star text-warning"></i>
                                    </div>
                                </div>
                                <div class="media-body">
                                    最近在补追此剧，特别喜欢这段表白。
                                    <br>
                                    <small class="text-muted">昨天 1:10</small>
                                </div>
                            </a>
                        </div>
                        <div class="sidebar-message">
                            <a href="#">
                                <div class="pull-left text-center">
                                    <img alt="image" class="img-circle message-avatar" src="../../assets/img/a4.jpg">
                                </div>
                                <div class="media-body">
                                    我发起了一个投票 【你认为下午大盘会翻红吗？】
                                    <br>
                                    <small class="text-muted">星期一 8:37</small>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>
                <div id="tab-3" class="tab-pane">

                    <div class="sidebar-title">
                        <h3> <i class="fa fa-cube"></i> 最新任务</h3>
                        <small><i class="fa fa-tim"></i> 您当前有14个任务，10个已完成</small>
                    </div>

                    <ul class="sidebar-list">
                        <li>
                            <a href="#">
                                <div class="small pull-right m-t-xs">9小时以后</div>
                                <h4>市场调研</h4> 按要求接收教材；

                                <div class="small">已完成： 22%</div>
                                <div class="progress progress-mini">
                                    <div style="width: 22%" class="progress-bar progress-bar-warning"></div>
                                </div>
                                <div class="small text-muted m-t-xs">项目截止： 4:00 - 2015.10.01</div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div class="small pull-right m-t-xs">9小时以后</div>
                                <h4>可行性报告研究报上级批准 </h4> 编写目的编写本项目进度报告的目的在于更好的控制软件开发的时间,对团队成员的 开发进度作出一个合理的比对

                                <div class="small">已完成： 48%</div>
                                <div class="progress progress-mini">
                                    <div style="width: 48%" class="progress-bar"></div>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div class="small pull-right m-t-xs">9小时以后</div>
                                <h4>立项阶段</h4> 东风商用车公司 采购综合综合查询分析系统项目进度阶段性报告武汉斯迪克科技有限公司

                                <div class="small">已完成： 14%</div>
                                <div class="progress progress-mini">
                                    <div style="width: 14%" class="progress-bar progress-bar-info"></div>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <span class="label label-primary pull-right">NEW</span>
                                <h4>设计阶段</h4>
                                <!--<div class="small pull-right m-t-xs">9小时以后</div>-->
                                项目进度报告(Project Progress Report)
                                <div class="small">已完成： 22%</div>
                                <div class="small text-muted m-t-xs">项目截止： 4:00 - 2015.10.01</div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div class="small pull-right m-t-xs">9小时以后</div>
                                <h4>拆迁阶段</h4> 科研项目研究进展报告 项目编号: 项目名称: 项目负责人:

                                <div class="small">已完成： 22%</div>
                                <div class="progress progress-mini">
                                    <div style="width: 22%" class="progress-bar progress-bar-warning"></div>
                                </div>
                                <div class="small text-muted m-t-xs">项目截止： 4:00 - 2015.10.01</div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div class="small pull-right m-t-xs">9小时以后</div>
                                <h4>建设阶段 </h4> 编写目的编写本项目进度报告的目的在于更好的控制软件开发的时间,对团队成员的 开发进度作出一个合理的比对

                                <div class="small">已完成： 48%</div>
                                <div class="progress progress-mini">
                                    <div style="width: 48%" class="progress-bar"></div>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div class="small pull-right m-t-xs">9小时以后</div>
                                <h4>获证开盘</h4> 编写目的编写本项目进度报告的目的在于更好的控制软件开发的时间,对团队成员的 开发进度作出一个合理的比对

                                <div class="small">已完成： 14%</div>
                                <div class="progress progress-mini">
                                    <div style="width: 14%" class="progress-bar progress-bar-info"></div>
                                </div>
                            </a>
                        </li>

                    </ul>

                </div>
            </div>

        </div>
    </div>
    <!--右侧边栏结束-->
    <!--mini聊天窗口开始-->
    <!-- <div class="small-chat-box fadeInRight animated">

        <div class="heading" draggable="true">
            <small class="chat-date pull-right">
                2015.9.1
            </small> 与 Beau-zihan 聊天中
        </div>

        <div class="content">

            <div class="left">
                <div class="author-name">
                    Beau-zihan <small class="chat-date">
                    10:02
                </small>
                </div>
                <div class="chat-message active">
                    你好
                </div>

            </div>
            <div class="right">
                <div class="author-name">
                    游客
                    <small class="chat-date">
                        11:24
                    </small>
                </div>
                <div class="chat-message">
                    你好，请问H+有帮助文档吗？
                </div>
            </div>
            <div class="left">
                <div class="author-name">
                    Beau-zihan
                    <small class="chat-date">
                        08:45
                    </small>
                </div>
                <div class="chat-message active">
                    有，购买的H+源码包中有帮助文档，位于docs文件夹下
                </div>
            </div>
            <div class="right">
                <div class="author-name">
                    游客
                    <small class="chat-date">
                        11:24
                    </small>
                </div>
                <div class="chat-message">
                    那除了帮助文档还提供什么样的服务？
                </div>
            </div>
            <div class="left">
                <div class="author-name">
                    Beau-zihan
                    <small class="chat-date">
                        08:45
                    </small>
                </div>
                <div class="chat-message active">
                    1.所有源码(未压缩、带注释版本)；
                    <br> 2.说明文档；
                    <br> 3.终身免费升级服务；
                    <br> 4.必要的技术支持；
                    <br> 5.付费二次开发服务；
                    <br> 6.授权许可；
                    <br> ……
                    <br>
                </div>
            </div>


        </div>
        <div class="form-chat">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control"> <span class="input-group-btn"> <button
                    class="btn btn-primary" type="button">发送
            </button> </span>
            </div>
        </div>

    </div> -->
    <!-- <div id="small-chat">
        <span class="badge badge-warning pull-right">5</span>
        <a class="open-small-chat">
            <i class="fa fa-comments"></i>

        </a>
    </div> -->
    <!--mini聊天窗口结束-->
  </div>

</template>
<script>
import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import getMenus from '../../com/menu' // url配置文件

export default {
  components: {
    MessageBox,
    Loading
  },
  name: 'app',
  data () {
    return {
      // 对象属性
      userName: '匿名',
      menus: [],
      loadingFlag: false,
      parentModuleIDs: '',
      // 账户余额
      surplus: ''
    }
  },
  methods: {
      addFUS(funID,childs){
        if(funID&&!childs){
            api.post(config.host + '/account/addFUS.do?funcID='+funID, {}).then((data) => {

            })
        }
      },
      goReCharge() {
        window.open(config.khsHost + 'h5_orgPay/payReCharge.html?token='+localStorage.getItem('Haiziguo-Token'))
      },
      reFreshReCharge() {
       let that = this
       api.post(config.khsHost + '/support/reChargeAndConsume/getReCharge.do',{}).then(function (json) {
       if (json.success === true) {
         that.surplus = json.body.surplus;
       }
    })
      },
    // 退出系统
    exitSys () {
      this.$confirm('确定退出系统?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
                    // 设置localstroge为空
        window.localStorage.clear()
                    // 跳转登录页
        window.location.href = './login.html'
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
        // 绑定事件
    bindEvent () {
      let self = this

            /**
             * hplug.js~-------------------------start------------------------------------
             */
            // MetsiMenu
      $('#side-menu').metisMenu()

      $('.logo-element').click(function () {
        $('body').removeClass('mini-navbar')
      })
            // 打开右侧边栏
      $('.right-sidebar-toggle').click(function () {
        $('#right-sidebar').toggleClass('sidebar-open')
      })

            // 右侧边栏使用slimscroll
      $('.sidebar-container').slimScroll({
        height: '100%',
        railOpacity: 0.4,
        wheelStep: 10
      })

            // 打开聊天窗口
      $('.open-small-chat').click(function (e) {
        $(e.currentTarget).children().toggleClass('fa-comments').toggleClass('fa-remove')
        $('.small-chat-box').toggleClass('active')
      })

            // 聊天窗口使用slimscroll
      $('.small-chat-box .content').slimScroll({
        height: '234px',
        railOpacity: 0.4
      })

            // Small todo handler
      $('.check-link').click(function (e) {
        var button = $(e.currentTarget).find('i')
        var label = $(e.currentTarget).next('span')
        button.toggleClass('fa-check-square').toggleClass('fa-square-o')
        label.toggleClass('todo-completed')
        return false
      })

            // 固定菜单栏
      $('.sidebar-collapse').slimScroll({
        height: '100%',
        railOpacity: 0.9,
        alwaysVisible: false
      })

            // 菜单切换
      $('.navbar-minimalize').click(function () {
        $('body').toggleClass('mini-navbar')
        self.SmoothlyMenu()
      })

      self.fix_height()

      $(window).bind('load resize click scroll', function () {
        if (!$('body').hasClass('body-small')) {
          self.fix_height()
        }
      })

            // 侧边栏滚动
      $(window).scroll(function () {
        if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav')) {
          $('#right-sidebar').addClass('sidebar-top')
        } else {
          $('#right-sidebar').removeClass('sidebar-top')
        }
      })
      $('.full-height-scroll').slimScroll({
        height: '100%'
      })
      $('#side-menu>li').click(function () {
        if ($('body').hasClass('mini-navbar')) {
          self.NavToggle()
        }
      })
      $('#side-menu>li li a').click(function () {
        if ($(window).width() < 769) {
          self.NavToggle()
        }
      })
      $('.nav-close').click(self.NavToggle)

            // ios浏览器兼容性处理
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        $('#content-main').css('overflow-y', 'auto')
      }

      $(window).bind('load resize', function (e) {
        if ($(e.currentTarget).width() < 769) {
          $('body').addClass('mini-navbar')
          $('.navbar-static-side').fadeIn()
        }
      })

            /**
             * contabs.js~-------------------------start------------------------------------
             */

            // 通过遍历给菜单项加上data-index属性
      $('.J_menuItem').each(function (index) {
        if (!$(this).attr('data-index')) {
          $(this).attr('data-index', index)
        }
      })

      $('.J_menuItem').on('click', self.menuItem)

      $('.J_menuTabs').on('click', '.J_menuTab i', self.closeTab)

      $('.J_tabCloseOther').on('click', self.closeOtherTabs)

      $('.J_tabShowActive').on('click', self.showActiveTab)

      $('.J_menuTabs').on('click', '.J_menuTab', self.activeTab)

      $('.J_menuTabs').on('dblclick', '.J_menuTab', self.refreshTab)

            // 左移按扭
      $('.J_tabLeft').on('click', self.scrollTabLeft)

            // 右移按扭
      $('.J_tabRight').on('click', self.scrollTabRight)

            // 关闭全部
      $('.J_tabCloseAll').on('click', function (e) {
        $('.page-tabs-content').children('[data-id]').not(':first').each(function () {
          $('.J_iframe[data-id="' + $(this).data('id') + '"]').remove()
          $(this).remove()
        })
        $('.page-tabs-content').children('[data-id]:first').each(function () {
          $('.J_iframe[data-id="' + $(this).data('id') + '"]').show()
          $(this).addClass('active')
        })
        $('.page-tabs-content').css('margin-left', '0')
      })
    },
        /**
         * hplug.js~-------------------------start------------------------------------
         */
        // 侧边栏高度
    fix_height () {
      var heightWithoutNavbar = $('body > #wrapper').height() - 61
      $('.sidebard-panel').css('min-height', heightWithoutNavbar + 'px')
    },
    NavToggle () {
      $('.navbar-minimalize').trigger('click')
    },
    SmoothlyMenu () {
      if (!$('body').hasClass('mini-navbar')) {
        $('#side-menu').hide()
        setTimeout(
                    function () {
                      $('#side-menu').fadeIn(500)
                    }, 100)
      } else if ($('body').hasClass('fixed-sidebar')) {
        $('#side-menu').hide()
        setTimeout(
                    function () {
                      $('#side-menu').fadeIn(500)
                    }, 300)
      } else {
        $('#side-menu').removeAttr('style')
      }
    },
        /**
         * contabs.js~-------------------------start------------------------------------
         */
        // 计算元素集合的总宽度
    calSumWidth (elements) {
      var width = 0
      $(elements).each(function () {
        width += $(this).outerWidth(true)
      })
      return width
    },
        // 滚动到指定选项卡
    scrollToTab (element) {
      let self = this
      var marginLeftVal = self.calSumWidth($(element).prevAll()), marginRightVal = self.calSumWidth($(element).nextAll())
            // 可视区域非tab宽度
      var tabOuterWidth = self.calSumWidth($('.content-tabs').children().not('.J_menuTabs'))
            // 可视区域tab宽度
      var visibleWidth = $('.content-tabs').outerWidth(true) - tabOuterWidth
            // 实际滚动宽度
      var scrollVal = 0
      if ($('.page-tabs-content').outerWidth() < visibleWidth) {
        scrollVal = 0
      } else if (marginRightVal <= (visibleWidth - $(element).outerWidth(true) - $(element).next().outerWidth(true))) {
        if ((visibleWidth - $(element).next().outerWidth(true)) > marginRightVal) {
          scrollVal = marginLeftVal
          var tabElement = element
          while ((scrollVal - $(tabElement).outerWidth()) > ($('.page-tabs-content').outerWidth() - visibleWidth)) {
            scrollVal -= $(tabElement).prev().outerWidth()
            tabElement = $(tabElement).prev()
          }
        }
      } else if (marginLeftVal > (visibleWidth - $(element).outerWidth(true) - $(element).prev().outerWidth(true))) {
        scrollVal = marginLeftVal - $(element).prev().outerWidth(true)
      }
      $('.page-tabs-content').animate({
        marginLeft: 0 - scrollVal + 'px'
      }, 'fast')
    },
        // 查看左侧隐藏的选项卡
    scrollTabLeft () {
      let self = this
      var marginLeftVal = Math.abs(parseInt($('.page-tabs-content').css('margin-left')))
            // 可视区域非tab宽度
      var tabOuterWidth = self.calSumWidth($('.content-tabs').children().not('.J_menuTabs'))
            // 可视区域tab宽度
      var visibleWidth = $('.content-tabs').outerWidth(true) - tabOuterWidth
            // 实际滚动宽度
      var scrollVal = 0
      if ($('.page-tabs-content').width() < visibleWidth) {
        return false
      } else {
        var tabElement = $('.J_menuTab:first')
        var offsetVal = 0
        while ((offsetVal + $(tabElement).outerWidth(true)) <= marginLeftVal) { // 找到离当前tab最近的元素
          offsetVal += $(tabElement).outerWidth(true)
          tabElement = $(tabElement).next()
        }
        offsetVal = 0
        if (self.calSumWidth($(tabElement).prevAll()) > visibleWidth) {
          while ((offsetVal + $(tabElement).outerWidth(true)) < (visibleWidth) && tabElement.length > 0) {
            offsetVal += $(tabElement).outerWidth(true)
            tabElement = $(tabElement).prev()
          }
          scrollVal = self.calSumWidth($(tabElement).prevAll())
        }
      }
      $('.page-tabs-content').animate({
        marginLeft: 0 - scrollVal + 'px'
      }, 'fast')
    },
        // 查看右侧隐藏的选项卡
    scrollTabRight () {
      let self = this
      var marginLeftVal = Math.abs(parseInt($('.page-tabs-content').css('margin-left')))
            // 可视区域非tab宽度
      var tabOuterWidth = self.calSumWidth($('.content-tabs').children().not('.J_menuTabs'))
            // 可视区域tab宽度
      var visibleWidth = $('.content-tabs').outerWidth(true) - tabOuterWidth
            // 实际滚动宽度
      var scrollVal = 0
      if ($('.page-tabs-content').width() < visibleWidth) {
        return false
      } else {
        var tabElement = $('.J_menuTab:first')
        var offsetVal = 0
        while ((offsetVal + $(tabElement).outerWidth(true)) <= marginLeftVal) { // 找到离当前tab最近的元素
          offsetVal += $(tabElement).outerWidth(true)
          tabElement = $(tabElement).next()
        }
        offsetVal = 0
        while ((offsetVal + $(tabElement).outerWidth(true)) < (visibleWidth) && tabElement.length > 0) {
          offsetVal += $(tabElement).outerWidth(true)
          tabElement = $(tabElement).next()
        }
        scrollVal = self.calSumWidth($(tabElement).prevAll())
        if (scrollVal > 0) {
          $('.page-tabs-content').animate({
            marginLeft: 0 - scrollVal + 'px'
          }, 'fast')
        }
      }
    },
    menuItem (e) {
      let self = this
      $('.J_menuItem').removeClass('on')
      $(e.currentTarget).addClass('on')
            // 获取标识数据
      var dataUrl = $(e.currentTarget).attr('src'),
        dataIndex = $(e.currentTarget).attr('data-index'),
        menuName = $.trim($(e.currentTarget).text()),
        cId = $(e.currentTarget).attr('cId'),
            flag = true,
            op = $(e.currentTarget).attr('op')
      if (dataUrl == undefined || $.trim(dataUrl).length == 0) return false
      // 选项卡菜单已存在
      $('.J_menuTab').each(function () {
        if ($(this).data('id') === dataUrl) {
          if (!$(this).hasClass('active')) {
            $(this).addClass('active').siblings('.J_menuTab').removeClass('active')
            self.scrollToTab(this)
            // 显示tab对应的内容区
            $('.J_mainContent .J_iframe').each(function () {
              if ($(this).data('id') === dataUrl) {
                if (cId && cId !== $(this).attr('cId')) {
                  $(this).remove()
                  var strC = '<iframe class="J_iframe" id="iframe' + dataIndex + '" cId="' + cId + '"  name="iframe' + dataIndex + '" width="100%" height="100%" src="' + dataUrl + '" frameborder="0" data-id="' + dataUrl + '" seamless></iframe>'
                  $('.J_mainContent').find('iframe.J_iframe').hide().parents('.J_mainContent').append(strC)
                } else {
                  $(this).show().siblings('.J_iframe').hide()
                }
                return false
              }
            })
          }
          flag = false
          return false
        }
			})



            // 选项卡菜单不存在
      if (flag) {
        var str = '<a href="javascript:" class="active J_menuTab" data-id="' + dataUrl + '">' + menuName + ' <i class="fa fa-times-circle"></i></a>'
        $('.J_menuTab').removeClass('active')

        // 添加选项卡对应的iframe
        var str1 = '<iframe class="J_iframe" id="iframe"'
        if (cId) {
          str1 += 'cId = "' + cId + '"'
        }
        str1 += '" name="iframe' + dataIndex + '" width="100%" height="100%" src="' + dataUrl + '" frameborder="0" data-id="' + dataUrl + '" seamless></iframe>'
        $('.J_mainContent').find('iframe.J_iframe').hide().parents('.J_mainContent').append(str1)

        // var iframeName = 'iframe' + dataIndex
            //     //显示loading提示
            //    var loading = layer.load()

            //    $('.J_mainContent iframe:visible').load(function () {
            //        //iframe加载完成后隐藏loading提示
            //        layer.close(loading)
            //    })
                // 添加选项卡
        $('.J_menuTabs .page-tabs-content').append(str)
        self.scrollToTab($('.J_menuTab.active'))
            }
        if(op) {
            var currentIframe = document.getElementsByClassName('J_iframe')[document.getElementsByClassName('J_iframe').length-1]
            if(!currentIframe.contentWindow.paramFromParent) {
                currentIframe.contentWindow.paramFromParent = op
                // console.log(currentIframe.contentWindow.paramFromParent)
            }
        }
      return false
    },
        // 关闭选项卡菜单
    closeTab (e) {
      let self = this
      var closeTabId = $(e.currentTarget).parents('.J_menuTab').data('id')
      var currentWidth = $(e.currentTarget).parents('.J_menuTab').width()

            // 当前元素处于活动状态
      if ($(e.currentTarget).parents('.J_menuTab').hasClass('active')) {
                // 当前元素后面有同辈元素，使后面的一个元素处于活动状态
        if ($(e.currentTarget).parents('.J_menuTab').next('.J_menuTab').size()) {
          var activeId = $(e.currentTarget).parents('.J_menuTab').next('.J_menuTab:eq(0)').data('id')
          $(e.currentTarget).parents('.J_menuTab').next('.J_menuTab:eq(0)').addClass('active')

          $('.J_mainContent .J_iframe').each(function () {
            if ($(this).data('id') == activeId) {
              $(this).show().siblings('.J_iframe').hide()
              return false
            }
          })

          var marginLeftVal = parseInt($('.page-tabs-content').css('margin-left'))
          if (marginLeftVal < 0) {
            $('.page-tabs-content').animate({
              marginLeft: (marginLeftVal + currentWidth) + 'px'
            }, 'fast')
          }

                    //  移除当前选项卡
          $(e.currentTarget).parents('.J_menuTab').remove()

                    // 移除tab对应的内容区
          $('.J_mainContent .J_iframe').each(function () {
            if ($(this).data('id') == closeTabId) {
                            // 结束增加销毁过程
              $(this).attr('src', 'about:blank')
              try {
                this.contentWindow.document.write('')
                this.contentWindow.document.clear()
              } catch (e) {}
                            // 结束销毁过程
              $(this).remove()
              return false
            }
          })
        }

                // 当前元素后面没有同辈元素，使当前元素的上一个元素处于活动状态
        if ($(e.currentTarget).parents('.J_menuTab').prev('.J_menuTab').size()) {
          var activeId = $(e.currentTarget).parents('.J_menuTab').prev('.J_menuTab:last').data('id')
          $(e.currentTarget).parents('.J_menuTab').prev('.J_menuTab:last').addClass('active')
          $('.J_mainContent .J_iframe').each(function () {
            if ($(this).data('id') == activeId) {
              $(this).show().siblings('.J_iframe').hide()
              return false
            }
          })

                    //  移除当前选项卡
          $(e.currentTarget).parents('.J_menuTab').remove()

                    // 移除tab对应的内容区
          $('.J_mainContent .J_iframe').each(function () {
            if ($(this).data('id') == closeTabId) {
                            // 结束增加销毁过程
              $(this).attr('src', 'about:blank')
              try {
                this.contentWindow.document.write('')
                this.contentWindow.document.clear()
              } catch (e) {}
                            // 结束销毁过程
              $(this).remove()
              return false
            }
          })
        }
      }
            // 当前元素不处于活动状态
      else {
                //  移除当前选项卡
        $(e.currentTarget).parents('.J_menuTab').remove()

                // 移除相应tab对应的内容区
        $('.J_mainContent .J_iframe').each(function () {
          if ($(this).data('id') == closeTabId) {
            $(this).remove()
            return false
          }
        })
        self.scrollToTab($('.J_menuTab.active'))
      }
      $('#side-menu').find('.J_menuItem').each(function () {
        if ($(this).attr('src') === closeTabId) {
          $(this).removeAttr('cid')
          return false
        }
      })
      return false
    },
        // 关闭其他选项卡
    closeOtherTabs () {
      $('.page-tabs-content').children('[data-id]').not(':first').not('.active').each(function () {
        $('.J_iframe[data-id="' + $(this).data('id') + '"]').remove()
        $(this).remove()
      })
      $('.page-tabs-content').css('margin-left', '0')
    },
        // 滚动到已激活的选项卡
    showActiveTab () {
      let self = this
      self.scrollToTab($('.J_menuTab.active'))
    },
        // 点击选项卡菜单
    activeTab (e) {
      let self = this
      if (!$(e.currentTarget).hasClass('active')) {
        var currentId = $(e.currentTarget).data('id')
                // 显示tab对应的内容区
        $('.J_mainContent .J_iframe').each(function () {
          if ($(this).data('id') == currentId) {
            $(this).show().siblings('.J_iframe').hide()
            return false
          }
        })
        $(e.currentTarget).addClass('active').siblings('.J_menuTab').removeClass('active')
        self.scrollToTab(this)
      }
    },
        // 刷新iframe
    refreshTab (e) {
      var target = $('.J_iframe[data-id="' + $(e.currentTarget).data('id') + '"]')
      var url = target.attr('src')
    //        //显示loading提示
    //        var loading = layer.load()
    //        target.attr('src', url).load(function () {
    //            //关闭loading提示
    //            layer.close(loading)
    //        })
    },
    consult () {
      window.open(config.host + './index/gotocustomerservice.html', 'qq')
    }

        /**
         * 进行排序集合
         *  */
        ,sortMenus(menus,order){
            if(menus){
                menus.forEach((item)=>{

                    if(item.childList){
                        item.childList=item.childList.sort(this.compareFunc(order))
                        this.sortMenus(item.childList,order)
                    }
                })


            }
        },
        /**
         * 根据属性进行排序
         */
        compareFunc(propertyName) {
            return function(obj1,obj2) {
                var val1,val2;
                val1 = obj1[propertyName];
                val2 = obj2[propertyName];
                if(val1 < val2) {
                    return -1;
                }else if(val1 > val2) {
                    return 1;
                }else {
                    return 0;
                }
            }
        }
  },
  beforeCreate: function () {
    this.loadingFlag = true
        // 创建前状态
  },
  created: function () {
		// 创建完毕状态
		var that = this
		getMenus('account/menu.do').then(data => {
            // 排序一次
            this.sortMenus(data,'orderNum')
			that.menus = data
			$('#content-main').html('<iframe class="J_iframe" name="iframe0" width="100%" height="100%" src="./main.html" frameborder="0" data-id="./main.html" seamless></iframe>')
		})
    api.post(config.khsHost + '/support/reChargeAndConsume/getReCharge.do',{}).then(function (json) {
       if (json.success === true) {
         that.surplus = json.body.surplus;
       }
    })
  },
  beforeMount: function () {
        // 挂载前状态
  },
  mounted: function () { // 挂载结束状态
    this.userName = window.localStorage.getItem('uname') === undefined ? '' : window.localStorage.getItem('uname')// 获取用户信息并显示
    // this.formatMenu()// 格式化菜单数据
  },
  beforeUpdate: function () {
        // 更新前状态
  },
  updated: function () {
        // 更新完成状态
    this.bindEvent()
        // 加载完毕隐藏lodaing
    this.loadingFlag = false
  },
  beforeDestroy: function () {
        // 销毁前状态
  },
  destroyed: function () {
        // 销毁完成状态
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #2c3e50
  margin-top: 60px
} */
.el-message{
    padding:15px;
    min-width:50px;
}
.logoSty{
    width: 64px;
    height: 64px;
    display: inline-block;
    background: #fff;
    border-radius: 40px;
}
.dropdown .msg{
    position: absolute;
    right:0px;
    color:#fff;
    background: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/module/index/app.vue?4ec38398